import { BASE_URL_V2 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'STUDENT_NODE_PATCH',
  PATCH_SUCCESS: 'STUDENT_NODE_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_NODE_PATCH_FAILURE',
};

export const patch = actions.patch(
  userNodeId => `${BASE_URL_V2}/student-nodes/${userNodeId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
